<template>
  <div class="modal" :class="{ mobile: isMobile }">
    <div
      class="modal-dialog modal-dialog-scrollable"
      :style="{ width }"
      v-click-outside="isCloseWhenClickOutside && closeModal"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title truncated">{{ modalTitle }}</h5>
          <slot name="header"></slot>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <div v-if="closeBtnText || confirmBtnText" class="modal-footer">
          <button
            v-if="closeBtnText"
            type="button"
            class="btn btn-secondary"
            :class="{ onlyWithCloseBtn: isOnlyWithCloseBtn }"
            data-dismiss="modal"
            @click="closeModal"
          >
            {{ closeBtnText }}
          </button>
          <button
            v-if="confirmBtnText"
            type="button"
            class="btn btn-primary"
            @click="confirm"
          >
            {{ confirmBtnText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as vClickOutside from 'v-click-outside';
import {
  addClassModalOpenOnBody,
  removeClassModalOpenFromBody
} from '../../utils/BOM';

export default {
  name: 'ModalContainer',
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    modalTitle: {
      type: String,
      required: true
    },
    widthOnMobile: {
      type: String,
      default: 'auto'
    },
    widthOnDesktop: {
      type: String,
      default: ' 60%'
    },
    closeBtnText: {
      type: String
    },
    confirmBtnText: {
      type: String
    },
    isCloseWhenClickOutside: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['isMobile']),
    isOnlyWithCloseBtn() {
      return this.closeBtnText && !this.confirmBtnText;
    },
    width() {
      return this.isMobile ? this.widthOnMobile : this.widthOnDesktop;
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
    confirm() {
      this.$emit('confirm');
    }
  },
  mounted() {
    // Prevent background page from scrolling when the modal is open.
    addClassModalOpenOnBody();

    // Close modal with 'esc' key
    document.addEventListener('keydown', e => {
      if (e.code == 'Escape') {
        this.isCloseWhenClickOutside && this.closeModal();
      }
    });
  },
  beforeDestroy() {
    // Allow background page to scroll when the modal is closed.
    removeClassModalOpenFromBody();
  }
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
}
.modal-dialog {
  max-width: initial;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}

.mobile {
  .modal-dialog {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
    max-width: 90%;
  }

  .modal-footer {
    display: flex;
    justify-content: center;

    .onlyWithCloseBtn {
      width: 90%;
    }
  }
}
</style>
